'use client';

import * as React from 'react';
import { useTheme } from './ThemeProvider';
import defaultTheme from './defaultTheme';
import { jsx as _jsx } from "react/jsx-runtime";
const ColorInversion = /*#__PURE__*/React.createContext(undefined);
export const useColorInversion = childVariant => {
  const overridableVariants = React.useContext(ColorInversion);
  return {
    /**
     * Resolve the `color` value for the component.
     * @param {ColorPaletteProp | 'inherit' | undefined} instanceColorProp The color defined on the instance.
     * @param {ColorPaletteProp | 'inherit' | undefined} defaultColorProp The default color to use when variant inversion is not enabled.
     */
    getColor: (instanceColorProp, defaultColorProp) => {
      if (overridableVariants && childVariant) {
        if (overridableVariants.includes(childVariant)) {
          // @ts-ignore internal logic
          return instanceColorProp || 'context';
        }
      }
      // @ts-ignore internal logic
      return instanceColorProp || defaultColorProp;
    }
  };
};
export function ColorInversionProvider({
  children,
  variant
}) {
  var _theme$colorInversion;
  const theme = useTheme();
  return /*#__PURE__*/_jsx(ColorInversion.Provider, {
    value: variant ?
    // `theme` could come from other emotion/styled-components context.
    ((_theme$colorInversion = theme.colorInversionConfig) != null ? _theme$colorInversion : defaultTheme.colorInversionConfig)[variant] : undefined,
    children: children
  });
}
export default ColorInversion;